import { IsNotEmpty } from "@pineapplelab/validators";
import { Paging } from "@pineapplelab/paging";
import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";

export class MailTemplate extends FBase{

  @IsNotEmpty()
  public subject: string;

  @IsNotEmpty()
  public text: string;

  @IsNotEmpty()
  public html: string;

  constructor(json?: { [key: string]: any }) {
    super();

    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace MailTemplate {
  export const PATH = 'mailTemplates';
  export const PAGING = new Paging<MailTemplate>(<Paging.IPaging>{
    collection: PATH,
    orderBy: 'subject'
});;

}
